import React, { useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import { Badge } from "reactstrap";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import LongMenu from "../../menuNPaper/long/LongMenu";
import CardBox from 'components/CardBox/index';
import { error, success } from "configs/CustomColors";
//import InsertChartIcon from '@material-ui/icons/InsertChart';
import StraightenIcon from '@material-ui/icons/Straighten';

const ListUnidades = ({ data, setEdit, setForm, alert }) => {
    return (
        <List>
            {data.map((item, index) => {
                return (
                    <CardBox
                        styleName="col-lg-12 col-md-6 col-12"
                        cardStyle="p-0"
                        heading={""}
                        headerOutside
                    >
                        <ListItem key={item.id}>
                            <ListItemAvatar>
                                <Avatar>
                                    <StraightenIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText style={{ width: "15%" }} className="br-break" primary={item.tx_representacao} />
                            <ListItemText style={{ width: "25%" }} className="br-break" primary={item.tx_nome} />
                            <ListItemText style={{ width: "50%" }} className="br-break" primary={item.tx_descricao} />
                            {/* <ListItemText style={{ width: "40%" }} className="br-break" />
                            <ListItemText className="br-break" /> */}

                            <Badge className="mr-4 mt-2 text-uppercase" style={{
                                backgroundColor: item.lo_ativo === 'S' ? success : error,
                                color: "white"
                            }} pill>{item.lo_ativo === 'S' ? "Ativo" : "Inativo"}</Badge>
                            <ListItemSecondaryAction>
                                <LongMenu locale="list" setForm={setForm} setEdit={setEdit} value={item} alert={alert} />
                            </ListItemSecondaryAction>
                        </ListItem>
                    </CardBox>
                );
            })}
        </List>
    );
};

export default ListUnidades;
